<template>
  <div @click="openModal($event)" :style="{width: width, height: height}" id="chart" ref="chart"></div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    data: {
      required: true,
      type: Array,
    },
    width: {
      type: String,
      default: '100%',
    },
    height: {
      type: String,
      default: '450px',
    },
  },
  mounted() {
    this.generateGraphics();
  },
  data() {
    return {
      chart: {},
    };
  },
  computed: {
    ...mapGetters([
      'am4core',
      'am4Charts',
    ]),
  },
  methods: {
    openModal(e) {
      if (e.target.hasAttribute('d')) {
        this.$emit('show-status');
      }
    },
    loaded() {
      setTimeout(() => {
        this.$emit('update-step', 3);
      }, 2000);
    },
    generateGraphics() {
      this.chart = this.am4core.create(this.$refs.chart, this.am4Charts.PieChart);

      this.chart.data = this.data;
      this.chart.width = this.am4core.percent(100);
      this.chart.numberFormatter.numberFormat = '#,###.##';
      this.chart.numberFormatter.decimalSeparator = ',';
      this.chart.numberFormatter.thousandsSeparator = '.';
      this.chart.y = this.am4core.percent(-8);
      this.chart.events.on('ready', () => this.loaded());


      const series = this.chart.series.push(new this.am4Charts.PieSeries());
      series.alignLabels = false;
      series.dataFields.value = 'value';
      series.marginRight = this.am4core.percent(-20);

      series.radius = this.am4core.percent(90);
      series.dataFields.category = 'name';
      series.labels.template.fontSize = 15;
      series.hiddenState.properties.opacity = 1;
      series.hiddenState.properties.endAngle = -90;
      series.hiddenState.properties.startAngle = -90;
      series.labels.template.text = '{value}';
      series.colors.list = [
        this.am4core.color('#46ccd9'),
        this.am4core.color('#d6dadd'),
      ];
      series.slices.template.states.getKey('active').properties.shiftRadius = 0;
      // customizing legend
      this.chart.legend = new this.am4Charts.Legend();
      const legend = this.chart.legend;
      legend.fontSize = 12;
      legend.useDefaultMarker = true;
      legend.width = this.am4core.percent(50);
      legend.x = this.am4core.percent(50);
      series.ticks.template.disabled = true;
      series.labels.template.disabled = true;
      legend.labels.template.truncate = true;
      legend.valueLabels.template.text = '{value}';

      // customizing each legend item
      const legendItemTemplate = legend.itemContainers.template;
      legendItemTemplate.paddingTop = 0;

      // customizing legend markers
      const markers = legend.markers.template;
      // size of markers in legend
      markers.width = 15;
      markers.height = 15;
    },
  },
  watch: {
    data: {
      deep: true,
      handler() {
        this.chart.data = this.data;
      },
    },
  },
};
</script>
<style scoped>
#chart {
  width: 100%;
  height: 100%;
}
.borders.fake {
  height: 8vh;
}
#chart >>> g[role="group"] {
  cursor: pointer;
}
</style>




// WEBPACK FOOTER //
// src/components/panelV2/ScheduleDaily/DailyLoad/Pie.vue